import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  ClassroomState,
  studentInterface as Student
} from '@/models';
import ClassroomStoreMock from '@/services/__mocks__/Classroom';
import SIS from '@/services/StudentInformationService';

const initialState: ClassroomState = ClassroomStoreMock;

export const fetchStudents = createAsyncThunk('classroom/fetchStudents', async (classroomId): Promise<Student[]> => {
  return await (SIS.getClassroom(classroomId) as Promise<ClassroomState>).then(classroom => classroom.students);
});

export const fetchClassroom = createAsyncThunk('classroom/fetchClassroom', async (classroomId): Promise<ClassroomState> => {
  return await SIS.getClassroom(classroomId) as Promise<ClassroomState>;
});

const classroomSlice = createSlice({
  name: 'classroom',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClassroom.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClassroom.fulfilled, (state, action) => {
        state.loading = false;
        state = action.payload;
      })
      .addCase(fetchClassroom.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch classroom';
      })
      .addCase(fetchStudents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudents.fulfilled, (state, action) => {
        state.loading = false;
        state.students = action.payload;
      })
      .addCase(fetchStudents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch students';
      });
  },
});

export default classroomSlice.reducer;